import React, { useMemo } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";

export default function EMValues() {
  const emImport = useSelector(
    (state: RootState) => state.imports?.importPreviews?.em,
    isEqual,
  );

  const pitBoostRace = useMemo(() => {
    if (!emImport?.data?.BBoostChargeExpectedVsNSessionTypeY) return null;
    const BBoostChargeExpectedVsNSessionTypeY =
      emImport.data.BBoostChargeExpectedVsNSessionTypeY;
    if (
      BBoostChargeExpectedVsNSessionTypeY[
        BBoostChargeExpectedVsNSessionTypeY.length - 1
      ] === 1
    ) {
      return true;
    }
    return false;
  }, [emImport]);

  const linearTarget = useMemo(() => {
    if (!emImport?.data?.BBoostChargeExpectedVsNSessionTypeY) return null;
    let energyBudget = emImport?.data.EFIARegulationStart;
    const BBoostChargeExpectedVsNSessionTypeY =
      emImport?.data.BBoostChargeExpectedVsNSessionTypeY;
    if (!BBoostChargeExpectedVsNSessionTypeY) return null;
    if (
      BBoostChargeExpectedVsNSessionTypeY[
        BBoostChargeExpectedVsNSessionTypeY.length - 1
      ] === 1
    ) {
      energyBudget += emImport.data.ERegBoostChargeOffset;
    }
    return (
      Math.round((energyBudget / emImport.data.NTotalLapsThisCar) * 100) / 100
    );
  }, [emImport]);

  return (
    <div className={styles.container}>
      <div>
        <b>Laps:</b> {emImport?.data.NTotalLapsThisCar || "None"}
      </div>
      <div>
        <b>Energy:</b> {emImport?.data.EFIARegulationStart || "None"} kWh
      </div>
      <div>
        <b>Pit Boost:</b> {pitBoostRace ? "True" : "False"}
      </div>
      <div>
        <b>Linear Target:</b> {linearTarget || "None"} kWh
      </div>
      <div>
        <b>Lap Distance:</b> {emImport?.data.sCircuitFromAtlas || "None"}m
      </div>
      <div>
        <b>Segments:</b> {emImport?.data.NMaxSegment || "None"}
      </div>
      <div>
        <b>Attack Segment:</b>{" "}
        {emImport?.data.NSegmentEMAttackModeStarts || "None"}
      </div>
      <div>
        <b>Last Corner Buffer:</b> {emImport?.data.EBufferLastCorner || "None"}{" "}
        kWh
      </div>
    </div>
  );
}
